// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"vP-z","categoryName":"wP-z","categoryNameSearchHeader":"xP-z","categoryContent":"yP-z","bottomAligned":"zP-z","image":"AP-z","imageNoBackground":"BP-z"};